export default function formatCurrency(
  price: number,
  currency: string,
  language: string
) {
  const decimalCount = (price.toString().split(".")[1] || "").length;

  return new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: decimalCount > 0 ? 2 : 0,
    maximumFractionDigits: 2
  }).format(price);
}

export function getCurrencySymbol(currency: string, language: string) {
  const currencySymbol = new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency
  })
    .formatToParts(1)
    .find((x) => x.type === "currency")?.value;
  return currencySymbol;
}

export function formatPriceWithCurrency(
  price: number,
  currency: string,
  language: string
): string {
  const currencySymbol = getCurrencySymbol(currency, language);
  return `${price} ${currencySymbol}`;
}
